import { TuiPreview, TuiPreviewDialogService, TuiTooltip } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { WorkflowFormFieldOutputFilesPopulated } from '@features/requests/request-form/components/request-form-workflows/types';
import { TuiDialogContext, TuiButton, TuiHint, TuiIcon } from '@taiga-ui/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiClamp, TuiSwipe, TuiSwipeEvent } from '@taiga-ui/cdk';
import { Subscriber } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { DeviceDetectorService } from '@core/services';

@Component({
  selector: 'x-output-files-field',
  imports: [
    TuiHint,
    TuiTooltip,
    TuiIcon,
    TuiPreview,
    TuiSwipe,
    TuiButton,
    AsyncPipe,
  ],
  templateUrl: './output-files-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputFilesFieldComponent {
  field = input.required<WorkflowFormFieldOutputFilesPopulated>();

  private readonly destroyRef = inject(DestroyRef);
  private readonly previewDialogService = inject(TuiPreviewDialogService);
  public readonly deviceService = inject(DeviceDetectorService);

  @ViewChild('imagePreview')
  readonly imagePreview?: TemplateRef<TuiDialogContext>;

  currentPreviewIndex = 0;
  previewLength = 0;

  showPreview(index: number): void {
    this.currentPreviewIndex = index;
    this.previewLength = this.field().files.length;

    this.previewDialogService
      .open(this.imagePreview || '')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  onSwipePreview(swipe: TuiSwipeEvent): void {
    if (swipe.direction === 'left') {
      this.currentPreviewIndex = tuiClamp(
        this.currentPreviewIndex + 1,
        0,
        this.previewLength - 1,
      );
    }

    if (swipe.direction === 'right') {
      this.currentPreviewIndex = tuiClamp(
        this.currentPreviewIndex - 1,
        0,
        this.previewLength - 1,
      );
    }
  }

  closePreview(observer: Subscriber<any>): void {
    observer.complete();
  }

  backdropClickClose(event: Event, observer: Subscriber<any>): void {
    if ((event.target as HTMLElement).tagName === 'TUI-PREVIEW') {
      this.closePreview(observer);
    }
  }

  get currentFile() {
    return this.field().files[this.currentPreviewIndex];
  }
}
